import axios from "axios";
import { ConcurrentRequestData, ConcurrentRequestApiResponse } from "../shared/interface/concurrentRequest.interface";

export const createConcurrentRequest = async (data: ConcurrentRequestData) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/parking/concurrent-request`, data);

    return response.data as ConcurrentRequestApiResponse;
  } catch (error) {
    throw error;
  }
};
